export default "__VITE_ASSET__CKtqoavG__"